import api from '../api'

export default {

  inboundAwaitingWaybill: async (page, take, sortBy, sortOrder, search, filters) => {
    return api.get(`api/shipping/inbound-awaiting-waybill?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },

  inboundWaybillCreate: async (id) => {
    return api.get(`api/shipping/inbound-awaiting-waybill/${id}/create`)
  },

  inboundWaybillStore: async job => {
    return api.post(`api/shipping/inbound-awaiting-waybill/${job.id}`,job)
  },

  outboundAwaitingWaybill: async (page, take, sortBy, sortOrder, search, filters) => {
    return api.get(`api/shipping/outbound-awaiting-waybill?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },

  outboundWaybillCreate: async id => {
    return api.get(`api/shipping/outbound-awaiting-waybill/${id}/create`)
  },

  outboundWaybillStore: async job => {
    return api.post(`api/shipping/outbound-awaiting-waybill/${job.id}`,job)
  },

  inbound: async (page, take, sortBy, sortOrder, search, filters) => {
    return api.get(`api/shipping/inbound?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },

  inboundReceivedCreate: async id => {
    return api.get(`api/shipping/inbound/${id}/create`,id)
  },

  inboundReceivedStore: async job => {
    return api.post(`api/shipping/inbound/${job.id}`,job)
  },

  outbound: async (page, take, sortBy, sortOrder, search, filters) => {
    return api.get(`api/shipping/outbound?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },

  outboundDeliveredCreate: async id => {
    return api.get(`api/shipping/outbound/${id}/create`)
  },

  outboundDeliveredStore: async job => {
    return api.post(`api/shipping/outbound/${job.id}`,job)
  },

  handoff: async (page, take, sortBy, sortOrder, search, filters) => {
    return api.get(`api/shipping/handoff?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },

  handedOffCreate: async id => {
    return api.get(`api/shipping/handoff/${id}/create`)
  },

  handedOffStore: async job => {
    return api.post(`api/shipping/handoff/${job.id}`,job)
  },

}
